import { useTranslation } from 'react-i18next';

import React, { useEffect, useState,useContext, createContext } from "react";
import {Table, Modal, Button, } from "antd";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import {useContractModel} from '../contractParticularsModel'
import {usecontractDetailsModel} from './detailsModel'
import { formatNum } from '@/erp_subpackage/utils/util';


export const  BillModal =({mode,})=>{
    const {t} = useTranslation()
    const  {meilageoneTotal,loading,serachmdetail,updateSearchParamm,descTotalt,billdetailData,mileageOrderdetailes,resetSearchParamm,addFormVal,lookFormVal,editFormVal,
    } =usecontractDetailsModel()
    const {open,setOpen}=useContractModel()
    const formval = mode==='edit'?editFormVal:mode==='look'?lookFormVal:addFormVal
   


    const column = [
        {
            title:  t(`contractManagement.view.billModal.对账单单号`),
            width: 120,
            dataIndex: 'billCode',
            fixed: "left"
        },
        {
            title:  t(`contractManagement.view.billModal.车辆牌照`),
            width: 100,
            dataIndex: 'vehicleCode',
            
        },
        {
            title:  t(`contractManagement.view.billModal.上月账单里程`),
            width: 100,
            dataIndex: 'mileageLast',
        }, {
            title:  t(`contractManagement.view.billModal.当前里程`),
            width: 100,
            dataIndex: 'mileageCurrent',
        },
        {
            title:  t(`contractManagement.view.billModal.运行里程`),
            width: 100,
            dataIndex: 'mileageDiff',
        }, {
            title:  t(`contractManagement.view.billModal.计费价格`),
            width: 100,
            dataIndex: 'billPrice',
            render:(text)=>text.toFixed(3)
        }, {
            title:  t(`contractManagement.view.billModal.账单金额`),
            width: 100,
            dataIndex: 'totalAmount',   
        }, {
            title:  t(`contractManagement.view.billModal.已收金额`),
            width: 100,
            dataIndex: 'paidAmount',
          
        },{
            title:  t(`contractManagement.view.billModal.应收金额`),
            width: 100,
            dataIndex: 'payableAmount',
           
            
        },
        {
            title:  t(`contractManagement.view.billModal.开始日期`),
            width: 150,
            dataIndex: 'billStartTime',
            
        },
        {
            title:  t(`contractManagement.view.billModal.结束日期`),
            width: 150,
            dataIndex: 'billEndTime',
           
            
        },
       
    ];
    const desc = [
    
        {
            label:  t(`contractManagement.view.billModal.费用金额`),
           value: "￥" + formatNum(meilageoneTotal.totalAmount?? 0),
            color: "red"
        },
        {
            label:  t(`contractManagement.view.billModal.已收金额`), 
            value: "￥" + formatNum(meilageoneTotal.paidAmount?? 0),
            color: "red"
        }, {
            label:  t(`contractManagement.view.billModal.应收金额`),
            
         value: "￥" + formatNum(meilageoneTotal.payableAmount?? 0),
            color: "red"
        },
        
    ]
    

        const searchFields1 = [ 
            {
                type: "Input",
                placeholder:  t(`contractManagement.view.billModal.车辆牌照`),
                fieldName: "vehicleCode"
            }, 
        ]
        
    return(
        <>
        <Modal
         title= { t(`contractManagement.view.billModal.对账单信息`)}
         open={open}
         onCancel={() => setOpen(false)}
         width={1700}
         footer={[]}
        >
       <YhBox descriptions={desc}>
        <div style={{marginLeft:'28px',marginTop:'-44px'}}>    
          <YhPageHeader
               size="small"
               justify="end"
               triggerSearch
               searchValues={serachmdetail}
               searchFields={searchFields1}
               onChange={updateSearchParamm}
               handleSearch={() => { mileageOrderdetailes({ ...serachmdetail,}) }}
               handleReset={resetSearchParamm}
            /> 
         </div>
            <Table
             rowKey={record => record.id}
               columns={column}  
               loading={loading}  
               scroll={{ x: 'max-content' }}
               dataSource={billdetailData}
            />
       
         </YhBox>
        </Modal>
        </>
    )
}
